var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 54,
    viewBox: "0 0 19 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3 2H14.7L16 12H17V20H15V22H4V20H2V12H3L4.3 2Z",
    fill: "#155878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7 2L16.1875 1.80663L16.0176 0.5H14.7V2ZM4.3 2V0.5H2.98238L2.81252 1.80663L4.3 2ZM16 12L14.5125 12.1934L14.6824 13.5H16V12ZM17 12H18.5V10.5H17V12ZM17 20V21.5H18.5V20H17ZM15 20V18.5H13.5V20H15ZM15 22V23.5H16.5V22H15ZM4 22H2.5V23.5H4V22ZM4 20H5.5V18.5H4V20ZM2 20H0.5V21.5H2V20ZM2 12V10.5H0.5V12H2ZM3 12V13.5H4.31762L4.48748 12.1934L3 12ZM14.7 0.5H4.3V3.5H14.7V0.5ZM17.4875 11.8066L16.1875 1.80663L13.2125 2.19337L14.5125 12.1934L17.4875 11.8066ZM17 10.5H16V13.5H17V10.5ZM18.5 20V12H15.5V20H18.5ZM15 21.5H17V18.5H15V21.5ZM13.5 20V22H16.5V20H13.5ZM15 20.5H4V23.5H15V20.5ZM5.5 22V20H2.5V22H5.5ZM2 21.5H4V18.5H2V21.5ZM0.5 12V20H3.5V12H0.5ZM3 10.5H2V13.5H3V10.5ZM2.81252 1.80663L1.51252 11.8066L4.48748 12.1934L5.78748 2.19337L2.81252 1.80663Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 22,
    width: 15,
    height: 30,
    fill: "#155878",
    stroke: "white",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.2241c756fba73f15024a42f74f17fdb8.svg";
export { ForwardRef as ReactComponent };